<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="content-chapter" id="_idParaDest-4"><a href="#/97816425039443#_idTextAnchor001">Adventure<span id="_idTextAnchor056"></span> </a></p>
<p class="body-paragraph-white _idGenParaOverride-1" xml:lang="en-US">When I was young, adventure meant going off with my sister or a group of friends to explore—whether that meant going to a mall and observing shoppers, biking to a faraway lake, or playing games in the woods behind our house. Today, not only does adventure mean being inspired by new experiences when I travel, but also being inspired by seeing everyday experiences with fresh eyes. It could be paying close attention to what I see on walks and hikes or even the thrilling experience of discovering something I love via online research.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97816425039447.vue?71e802e4